import { assert } from '../../lib/assert-sidecar'
import { rando } from '../../lib/rando-sidecar'
import { common } from '../../main/common-sidecar'
import type { IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageCrew_fire } from './voyageCrew_fire-sidecar'
import { voyageCrew_hullBreach } from './voyageCrew_hullBreach-sidecar'
import { voyageGameStatus } from './voyageGameStatus-sidecar'
import { voyageParticles } from './voyageParticles-sidecar'
import { voyageSounds } from './voyageSounds-sidecar'
import { voyageSystems } from './voyageSystems-sidecar'
import { crewUpdate } from './voyageSystems_cryo'
import { voyageTilemap } from './voyageTilemap-sidecar'

const _offsets9 = [
  [0, 0],

  [0, -1],
  [1, -1],
  [1, 0],
  [1, 1],

  [0, 1],
  [-1, 1],
  [-1, 0],
  [-1, -1],
]

export interface IVoyageCrewCrew {
  fireExtinguishTimer: number
  repairTimer: number
  useSystemTimer: number
  oxygenTimer: number
}

export function create() {
  let d: IVoyageCrewCrew = {
    fireExtinguishTimer: 0,
    useSystemTimer: 0,
    repairTimer: 0,
    oxygenTimer: 0,
  }
  return d
}

export function update(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.crewState
  assert.notNil(d)

  if (obj.isDead) {
    return
  }
  if (obj.hitpoints <= 0) {
    voyageCrew.kill(obj)
    return
  }

  if (obj.path) {
    return // moving
  }

  const oxygenTime = 2
  let status = voyageGameStatus.get()
  d.oxygenTimer += ds
  if (d.oxygenTimer > oxygenTime) {
    d.oxygenTimer -= oxygenTime

    if (status.oxygen < 15) {
      if (rando.chance(0.25)) {
        let phrases = [
          'It is tough to breathe',
          'Someone check life support',
          '',
        ]
        voyageCrew.say(obj, rando.sample(phrases))
      }
    }

    if (status.oxygen < 5) {
      let phrases = [
        '*gasp*',
        'Oxygen!',
        'O2!',
        'I need air!',
        'Get to life support quick!',
        '',
        '',
      ]
      voyageCrew.say(obj, rando.sample(phrases))
      voyageCrew.hurt(obj, 5, 'Asphyxiation')
      voyageParticles.createMultiple('oxygen', obj.x, obj.y, rando.i(1, 3))
    }
  }

  let tCur = voyageTilemap.getSafeIJ(obj)
  if (tCur) {
    voyageSystems.useSystem(obj, tCur)
  }

  if (voyageGameStatus.get().hasFire.isActive) {
    let tHere = voyageTilemap.getSafeIJ(obj)
    if (tHere) {
      if (tHere.fire) {
        const fireDamage = 25
        voyageCrew.hurt(obj, ds * fireDamage, 'Combusted')
      }
    }

    d.fireExtinguishTimer += ds
    const fireExtinguishTime = 1.5
    if (d.fireExtinguishTimer > fireExtinguishTime) {
      d.fireExtinguishTimer -=
        fireExtinguishTime + rando.fs(fireExtinguishTime * 0.25)

      for (let i = 0; i < _offsets9.length; i++) {
        let os = _offsets9[i]
        let tCheck = voyageTilemap.getSafeOffset(obj, os[0], os[1])
        if (tCheck) {
          if (tCheck.fire) {
            voyageCrew_fire.hurt(tCheck.fire)
            voyageSounds.playFireExtinguisher()
            voyageParticles.createMultiple(
              'fire-extinguisher',
              tCheck.x,
              tCheck.y + 8,
              5,
            )
            // Only one
            break
          }
        }
      }
    }
  }

  if (voyageGameStatus.get().hasBreach.isActive) {
    d.repairTimer += ds
    const repairTime = 0.75
    if (d.repairTimer > repairTime) {
      d.repairTimer -= repairTime + rando.fs(repairTime * 0.25)

      for (let i = 0; i < _offsets9.length; i++) {
        let os = _offsets9[i]
        let tCheck = voyageTilemap.getSafeOffset(obj, os[0], os[1])
        if (tCheck) {
          if (tCheck.breach) {
            voyageCrew_hullBreach.hurt(tCheck.breach)
            voyageSounds.playRepair()

            voyageParticles.createMultiple(
              'heal-hull',
              tCheck.x,
              tCheck.y + 8,
              rando.i(2, 4),
            )

            // Only one
            break
          }
        }
      }
    }
  }
}
